import EntertainmentModel    from '@/models/services/shop/EntertainmentModel';
import ShopServiceModel      from '@/models/ShopServiceModel';
import { SupportedLanguage } from '@/hooks/useTranslations';
import doc                   from '@widesk-core/decorators/doc';
import model                 from '@widesk-core/decorators/model';
import Translatable          from '@widesk-core/models/traits/Translatable';

export type ProductStatusReference = 'in_creation' | 'enabled' | 'disabled';

@model.urnResource('product')
@doc.path('/products/{?id}')
export default class ProductModel extends Translatable(ShopServiceModel, {
	'title': true,
}) {
	private declare _tsFilters: {
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'entertainment': id;
		'entertainment.entertainmentUrn': Urn;
		'productStatus': id;
		'productTaxonomies.taxonomy': id;
		'slug': id;
		'productStatus.reference': ProductStatusReference;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	};

	private declare _tsSorts: {
		'id': string;
		'position': string;
		'createdAt': string;
		'updatedAt': string;
	};

	@doc.model(EntertainmentModel) declare entertainment: EntertainmentModel;
	@doc.boolean declare multiVariant: boolean;
	@doc.string declare image: string; // Cette propriété n'existe pas sur l'api
	@doc.string declare imageName: string; // Cette propriété n'existe pas sur l'api

	public getTitle(language: SupportedLanguage) {
		return this.get(`translations.${language}.title`, '');
	}
}